var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-company-info-wrapper",
    { attrs: { company: _vm.value, "no-scroll": "" } },
    [
      _c(
        "w-button-bar",
        { attrs: { slot: "actions" }, slot: "actions" },
        [
          _c(
            "w-button",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: _vm.showUserInfoToolTip,
                  expression: "showUserInfoToolTip",
                },
              ],
              attrs: { disabled: _vm.notAllowedToView },
              on: {
                click: function ($event) {
                  return _vm.showUserInfo()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "eye" } })],
            1
          ),
          _c(
            "w-button",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: _vm.createTicketTooltip,
                  expression: "createTicketTooltip",
                },
              ],
              attrs: { disabled: _vm.notAllowedToView },
              on: {
                click: function ($event) {
                  return _vm.createTicket()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "life-ring" } })],
            1
          ),
          _c(
            "app-login-as-user-button",
            {
              attrs: {
                admin: "",
                clsas: "link",
                disabled: _vm.selected.length != 1,
                user: _vm.selected[0],
              },
            },
            [
              _c(
                "w-button",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: "Aanmelden met admin rechten",
                      expression: "'Aanmelden met admin rechten'",
                    },
                  ],
                  attrs: { disabled: _vm.selected.length != 1 },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                    },
                  },
                },
                [
                  _c("w-fa", {
                    staticClass: "sign-in-button",
                    attrs: { icon: "headset" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "app-login-as-user-button",
            {
              attrs: {
                clsas: "link",
                disabled: _vm.selected.length != 1,
                user: _vm.selected[0],
              },
            },
            [
              _c(
                "w-button",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: "Aanmelden als gebruiker",
                      expression: "'Aanmelden als gebruiker'",
                    },
                  ],
                  attrs: { disabled: _vm.selected.length != 1 },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                    },
                  },
                },
                [
                  _c("w-fa", {
                    staticClass: "sign-in-button",
                    attrs: { icon: "sign-in-alt" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        { attrs: { grow: "" } },
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c("w-data-table", {
                staticStyle: { "flex-grow": "1" },
                attrs: {
                  items: _vm.orderedUsers,
                  columns: _vm.columns,
                  order: _vm.orderColumn,
                  "order-direction": _vm.orderDirection,
                  "selected-items": _vm.selected,
                },
                on: {
                  order: function ($event) {
                    return _vm.onOrder($event)
                  },
                  "item-clicked": function ($event) {
                    return _vm.showUserInfo($event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.editModal,
            callback: function ($$v) {
              _vm.editModal = $$v
            },
            expression: "editModal",
          },
        },
        [
          _c("app-company-info-user-modal", {
            attrs: { value: _vm.toShowUser },
            on: {
              close: function ($event) {
                _vm.editModal = false
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }